import * as yup from 'yup';
import { parseNumber } from '../../utils/floatToCurrency';
import { validEmail, validPhoneCharacters } from '../../utils/regex';

export const brokerSchema = yup.object().shape({
  fromEmail: yup
    .string()
    .trim()
    .matches(validEmail, 'Please enter a valid email address')
    .required('Please enter your email address'),
  fromTelephone: yup
    .string()
    .trim()
    .matches(validPhoneCharacters, 'Please enter a valid phone number')
    .required('Please enter your phone number'),
  fromName: yup.string().trim().required('Please enter your name'),
  propertyValue: yup
    .number()
    .transform((_, originalValue) => parseNumber(originalValue))
    .moreThan(-1, 'Property Value must be a positive value')
    .required('Please enter a Property Value'),
  deposit: yup
    .number()
    .transform((_, originalValue) => parseNumber(originalValue))
    .moreThan(-1, 'Deposit Value must be a positive value')
    .required('Please enter a Deposit Value'),
  paymentTerm: yup
    .number()
    .transform((_, originalValue) => parseNumber(originalValue))
    .required('Please enter a Property Term'),
});

export default brokerSchema;
